import { SkeletonNoLoginComponent } from 'commons/components';
import { useAuth } from 'oidc-react';
import { useEffect, useMemo, useState } from 'react';
import { AuthContext } from '../contexts/auth.context';
import { getMostPrivilegedRole } from '../business/auth-role.business';
import { setInactivityTimeout } from '../services/session-inactivity.service';

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
    const auth = useAuth();
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<string | null>('');

    useEffect(() => {
        if (auth?.userData?.access_token) {
            setIsAuthenticated(true);
            const arrayToken = auth?.userData?.access_token.split('.');
            const tokenRoles = JSON.parse(atob(arrayToken[1])).roles;

            setUserRole(getMostPrivilegedRole(tokenRoles));
        }
    }, [auth?.userData?.access_token]);

    const contextValue = useMemo(
        () => ({ isAuthenticated, userRole, isLoading: auth.isLoading, auth }),
        [isAuthenticated, userRole, auth.isLoading, auth]
    );

    useEffect(() => {
        if (isAuthenticated) {
            setInactivityTimeout(auth);
        }
    }, [auth]);

    return (
        <AuthContext.Provider value={contextValue}>
            {auth?.isLoading || !auth?.userData?.access_token || userRole?.length === 0 ? (
                <SkeletonNoLoginComponent />
            ) : (
                children
            )}
        </AuthContext.Provider>
    );
};
